<div class="cgu-popup">
  <div class="popup-description">
    <p class="description-text">
      {{ 'popup.cgu.description' | translate }}
    </p>
  </div>

  <div class="cgu-link">
    <a href="/assets/CGV.MYPACS.2023.VF.pdf" target="_blank" class="pdf-link">
      <mat-icon>description</mat-icon>
      <span>{{ 'popup.cgu.read_link' | translate }}</span>
      <mat-icon class="open-icon">open_in_new</mat-icon>
    </a>
  </div>

  <div class="cgu-checkbox">
    <mat-checkbox [formControl]="acceptedControl" color="primary">
      {{ 'popup.cgu.checkbox' | translate }}
    </mat-checkbox>
  </div>
</div>
